import React, { useState, useEffect } from 'react';
import styles from './AppleFooter.module.css';
import { Container } from 'reactstrap';
import NeedHelp from '../../modals/NeedHelp/NeedHelp';
import { getCustomerRedirectUrls } from '../../../helpers';

export default function AppleFooter() {
    const [coverageDocsLink, setCoverageDocsLink] = useState('');

    const getRedirectUrls = async () => {
        const data = await getCustomerRedirectUrls('apple').then((urlResponse) => {
            return {
                coverageURL: urlResponse?.coverageDocsUrl
            };
        });

        setCoverageDocsLink(data?.coverageURL);
    };

    useEffect(() => {
        //Fetch Coverage Docs link
        getRedirectUrls();
    }, []);

    return (
        <>
            <div className={styles.preFooterColorContainer}>
                <Container
                    className={styles.preFooter}
                    role='complementary'
                >
                    <div className={styles.legal}>
                        <p>
                            AppleCare+ provides coverage for mechanical failure, electrical failure and accidental
                            damage from handling (ADH). AIG Standalone Protection does not provide coverage for
                            mechanical failure, electrical failure and accidental damage from handling (ADH). For
                            complete details, see the{' '}
                            <a
                                href={coverageDocsLink}
                                target='_blank'
                            >
                                coverage details
                            </a>{' '}
                            applicable to your state.
                        </p>
                        <p className='mb-0'>
                            AIG Standalone Protection Plans are sold and administered by AIG WarrantyGuard, Inc., part
                            of AIG, or one or more of its affiliates. Plans are subject to detailed terms, conditions
                            and limitations. For further information, please review the full plan{' '}
                            <a
                                href={coverageDocsLink}
                                target='_blank'
                            >
                                terms and conditions
                            </a>
                            . Apple is not affiliated with AIG or any of its affiliates. Apple trademarks used with
                            permission.
                        </p>
                    </div>
                </Container>
            </div>
            <footer
                className='mt-0'
                aria-label='Footer'
            >
                <Container className={styles.footerContainer}>
                    <ul className='horzList'>
                        <li>
                            <a
                                href='https://www.aig.com/privacy-policy'
                                target='_blank'
                            >
                                Privacy Policy
                            </a>
                        </li>
                        <li>
                            <a
                                href='https://www.aig.com/terms-of-use'
                                target='_blank'
                            >
                                Terms of Use
                            </a>
                        </li>
                        <li>
                            <a
                                href='https://www.aig.com/cookie-policy'
                                target='_blank'
                            >
                                Cookie Policy
                            </a>
                        </li>
                    </ul>

                    <p>
                        Copyright &#169; {new Date().getFullYear()}, American International Group, Inc. All rights
                        reserved.
                    </p>

                    <NeedHelp />
                </Container>
            </footer>
        </>
    );
}
